import { translateFormatter } from '@/domains/core/localization/translate';
export const metaDescription = translateFormatter<{
  title: string;
  sku: string;
}>([{
  "type": 0,
  "value": "IN STOCK: best prices on "
}, {
  "type": 1,
  "value": "title"
}, {
  "type": 0,
  "value": ", "
}, {
  "type": 1,
  "value": "sku"
}, {
  "type": 0,
  "value": "."
}], undefined, undefined, "en");